// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var firmRouter = {
  path: '/firm',
  component: Layout,
  redirect: '/firm/index',
  name: 'firm',
  meta: {
    title: '企业管理',
    icon: 'clipboard'
  },
  children: [{
    path: 'index',
    component: function component() {
      return import('@/views/firm/page.vue');
    },
    name: 'firmIndex',
    meta: {
      title: '企业管理',
      icon: ''
    }
  }]
};
export default firmRouter;